<script lang='ts'>
import { reactive, defineComponent } from '@vue/composition-api';

interface IProps {
    steps: number;
    currentStep: number;
}

const AppWizardProgress = defineComponent({
    name: 'AppWizardProgress',
    props: { steps: Number, currentStep: Number },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props: IProps, ctx) {
        const state = reactive({});

        return {
            state,
        };
    },
});

export default AppWizardProgress;
</script>

<template>
  <div class="d-flex align-center">
    <div
      v-for="step in steps"
      :key="step"
      style="display: contents;"
    >
      <div
        class="d-flex align-center justify-center step-item"
        :class="{current: step === currentStep}"
        style="width: 28px; height: 28px; border-radius: 50%"
      >
        {{ step }}
      </div>

      <div v-if="step < steps" style="height: 1px; border-top: 2px dashed var(--v-primary-base) !important;" class="mx-1 flex-grow-1" />
    </div>
  </div>
</template>

<style lang='scss' scoped>
.step-item {
    background-color: var(--v-white-base);
    color: var(--v-primary-base);
    border: 1px solid var(--v-primary-base) !important;

    &.current {
        background-color: var(--v-primary-base);
        color: var(--v-white-base);
    }
}
</style>